export default __webpack_public_path__ + "static/058-fc814f721efe57f838db211fc424d8a0.jpg";